/* eslint-disable no-console */
/* justification: intentional browser console output for logging module */

import type { LoggerClient } from './client';
import { originalConsole } from './remote';

type LogLevel = 'error' | 'warn' | 'info' | 'debug';

const createLogDispatcher =
  (level: LogLevel, isConsoleActive: boolean) =>
  (msg: string, ctx: unknown): void => {
    const localSetting = window?.localStorage.getItem('useConsoleLogging');
    const useConsoleLogging = localSetting === 'true';
    // In development we always print to the browser DevTools console so
    // developers can see the same log lines that are being forwarded to the
    // server terminal by `remote.ts`. Prod still respects the config flag /
    // localStorage opt-in to avoid noisy customer consoles.
    const isDev = process.env.NODE_ENV !== 'production';

    if (isDev || isConsoleActive || useConsoleLogging) {
      // Use the captured original so the console mirror in remote.ts
      // doesn't re-forward this record (the pino remote client already did).
      originalConsole[level](msg, ctx);
    }
  };

export const createConsoleLogger = (
  isConsoleActive: boolean
): LoggerClient => ({
  error: createLogDispatcher('error', isConsoleActive),
  warn: createLogDispatcher('warn', isConsoleActive),
  info: createLogDispatcher('info', isConsoleActive),
  debug: createLogDispatcher('debug', isConsoleActive),
});
